import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'FEEDBACK_UPDATE',
    smsDelete : 'FEEDBACK_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        feedback: [],
        feedbackLoading: false,
        feedbackError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_FEEDBACK(state, feedback) {
            state.feedback = feedback;
        },

        FEEDBACK_LOADING (state, loading) {
            state.feedbackLoading = loading;
        },

        FEEDBACK_ERROR (state, hasError) {
            state.feedbackError = hasError;
        }
    },

    actions: {
        async fetchFeedback ({ commit }) {
            commit('FEEDBACK_LOADING', true);
            commit('FEEDBACK_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.feedback_list, config);
                let response = result.data
                commit('SET_FEEDBACK', response.data);

            } catch(error) {
                commit('FEEDBACK_ERROR', true);
            } finally {
                commit('FEEDBACK_LOADING', false);
            }
        },
        
        async deleteFeedback({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.feedback_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchFeedback')
            return response
        }
    },

    getters: {}
}
